import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BannerList } from 'src/app/shared/interfaces/resource.interface';

export enum CarouselType {
  Front = 'FrontPage',
  Games = 'GamesPage',
  Lottery = 'LotteryPage',
  Sport = 'SportPage',
  SubSport = 'SubSportPage',
  LiveCasino = 'LiveCasinoPage',
  ESport = 'ESportPage',
  SubESport = 'SubESportPage',
}
export type CarouselData = {
  img: string;
  href: string;
  id: number;
  title: string;
  customizedHref: string;
  gameProvider: string;
};

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class BannerManagerService {
  private _allCarouselData = new Map<CarouselType, CarouselData[]>();

  get(buildFor: CarouselType): CarouselData[] | undefined {
    return this._allCarouselData.get(buildFor);
  }

  set(buildFor: CarouselType, data: CarouselData[]): void {
    this._allCarouselData.set(buildFor, data);
  }

  has(buildFor: CarouselType): boolean {
    return this._allCarouselData.has(buildFor);
  }

  transformCarouselData(apiData: BannerList[], languageCode: string): CarouselData[] {
    return apiData.map(x => ({
      id: x.id,
      img: x.bannerUrl,
      href: x.imageUrl,
      title: x.title,
      customizedHref: x.imageUrl?.startsWith('http')
        ? x.imageUrl
        : `${window.location.origin}/${languageCode}${x.imageUrl}`,
      gameProvider: x.gameProvider,
    }));
  }
}
